import React from "react";
import { connect } from "react-redux";
import { CustomerEditLogContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { portalService } from "apiServices";
import momentTZ from "moment-timezone";
import moment from "moment";
import {
  RENDER_EDIT_BY_TYPE,
  RENDER_GENDER_TYPE,
} from "utils/functions/customer";
import { RENDER_CHARACTER_REPLACE_BY_PERMISSION } from "utils/functions/string";
import { AlertControl } from "components/Modals/Alert";
import { toast } from "react-toastify";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Displays, Tables, Buttons } from "components";

class CustomerEditLogContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let resArr = await Promise.all([
      this.fetchCustomerDetail(),
      this.fetchPDPA(),
      this.fetchLogData(),
    ]);
    if (resArr) {
      let findPDPALatest = resArr[1].find(
        (e) => e.pdpa_ref_id === resArr[0].pdpa_accepted_latest_ref_id
      );
      let logData = resArr[2].docs;
      this.setState({
        data: resArr[0],
        pdpaLatest: findPDPALatest,
        logData: logData,
        isLoading: false,
        isBgLoading: false,
      });
    }
  };
  fetchCustomerDetail = async () => {
    let res = await portalService.GET_CUSTOMER_DETAIL(
      this.props.router.params.id
    );
    if (res && res.status === 200) {
      return res.data;
    }
  };
  fetchPDPA = async () => {
    let res = await portalService.GET_PDPA_HISTORY_LIST_BY_CUSTOMER_ID(
      this.props.router.params.id,
      `?pagination=false`
    );
    if (res && res.status === 200) {
      return res.data;
    }
  };
  fetchLogData = async () => {
    let res = await portalService.GET_CUSTOMER_EDIT_LOG(
      this.props.router.params.id
    );
    if (res && res.status === 200) {
      return res.data;
    }
  };

  handleClickBack = (e) => {
    this.props.router.navigate(-1);
  };

  handleClickDelete = async () => {
    const { data } = this.state;
    AlertControl.show({
      title: "ยืนยันการลบ",
      description: "คุณต้องการจะลบใช่หรือไม่",
      btnLabel1: "ยกเลิก ",
      btnLabel2: "ยืนยัน",
      onEvent2: async () => {
        this.setState({
          isBgLoading: true,
        });
        let res = await portalService.DELETE_CUSTOMER_DETAIL(data._id);
        if (res && res.status === 200) {
          toast.success("ลบสำเร็จ");
          this.setState({
            isBgLoading: false,
          });
          this.props.router.navigate(-1);
        } else {
          toast.error("ลบไม่สำเร็จ");
        }
      },
    });
  };

  handleClickEditCustomer = () => {
    const id = this.state.data._id;
    this.props.router.navigate(`${ROUTE_PATH.CUSTOMER}/edit/${id}`);
  };

  render() {
    const { authenRedux } = this.props;
    const { isLoading, isBgLoading, data, pdpaLatest, logData } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "customer");
    return (
      <CustomerEditLogContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <>
            <div className="block_section mb_1">
              <div className="title">รายละเอียดลูกค้า</div>
              <div className="cus_info_row">
                <div className="ci_left_col">
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      label={"ชื่อ"}
                      value={`${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                        ...permission,
                        inputString: data.first_name,
                      })} ${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                        ...permission,
                        inputString: data.last_name,
                      })}`}
                    />
                  </div>
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      label={"เบอร์โทร"}
                      value={RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                        ...permission,
                        inputString: data.phone_number,
                        type: "phone",
                      })}
                    />
                  </div>
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      label={"เพศ"}
                      value={RENDER_GENDER_TYPE(data.gender).labelTh}
                    />
                  </div>
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      label={"จังหวัด"}
                      value={`${data.province}`}
                    />
                  </div>
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      label={"วันเกิด"}
                      value={momentTZ(data.birthday)
                        .tz("Asia/Bangkok")
                        .format("DD/MM/YYYY")}
                    />
                  </div>
                  <div className="value_item_wrap">
                    <Displays.LabelValue label={"อีเมล"} value={data.email} />
                  </div>
                  {(data.register_type === "2" || data.register_type === "4") &&
                    permission &&
                    permission.is_delete && (
                      <div className="value_item_wrap">
                        <Displays.LabelValue
                          label={"รีเซ็ตไลน์ไอดี"}
                          value={
                            <button
                              type="button"
                              className="btn_delete red_head"
                              onClick={() => this.handleRelink(data._id)}
                            >
                              Unlink ระบบ Line OA
                            </button>
                          }
                        />
                      </div>
                    )}
                </div>
                <div className="ci_right_col">
                  {pdpaLatest && (
                    <>
                      <div className="value_item_wrap">
                        <Displays.LabelValue
                          label={"PDPA code"}
                          value={`${pdpaLatest.pdpa_code}`}
                        />
                      </div>
                      <div className="value_item_wrap">
                        <Displays.LabelValue
                          label={"ยอมรับวันที่"}
                          value={`${moment(pdpaLatest.accepted_at).format(
                            "DD/MM/YYYY"
                          )}`}
                        />
                      </div>
                      <div className="value_item_wrap">
                        <Displays.LabelValue
                          label={"Privacy"}
                          value={`${
                            pdpaLatest.is_accepted_privacy_pdpa ? "Yes" : "No"
                          }`}
                        />
                      </div>
                      <div className="value_item_wrap">
                        <Displays.LabelValue
                          label={"Warranty"}
                          value={`${
                            pdpaLatest.is_accepted_product_warranty_pdpa
                              ? "Yes"
                              : "No"
                          }`}
                        />
                      </div>
                      <div className="value_item_wrap">
                        <Displays.LabelValue
                          label={"True info"}
                          value={`${
                            pdpaLatest.is_accepted_certified_true_info_pdpa
                              ? "Yes"
                              : "No"
                          }`}
                        />
                      </div>
                      <div className="value_item_wrap">
                        <Displays.LabelValue
                          label={"Maketing"}
                          value={`${
                            pdpaLatest.is_accepted_marketing_pdpa ? "Yes" : "No"
                          }`}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="block_section">
              <div className="title_wrap">
                <div className="title">ประวัติการแก้ไขข้อมูลสมาชิก</div>
                <div className="btn_edit">
                  <Buttons.BgStandard
                    theme_export_btn
                    label={"Edit"}
                    onClick={this.handleClickEditCustomer}
                  />
                </div>
              </div>
              <div className="body">
                <Tables.Standard
                  columns={editHistoryColumns()}
                  // data={_mockHistoryData}
                  data={logData}
                />
              </div>
            </div>

            <div className="box_back">
              <div className="w150">
                <Buttons.BgStandard
                  theme_gray
                  label="Back"
                  onClick={this.handleClickBack}
                />
              </div>
              {/* {permission && permission.is_delete && (
                <div className="w150">
                  <Buttons.BgStandard
                    theme_red
                    label="Delete"
                    onClick={this.handleClickDelete}
                  />
                </div>
              )} */}
            </div>
          </>
        )}
      </CustomerEditLogContainerStyled>
    );
  }
}

const editHistoryColumns = () => [
  {
    Header: <div style={{ textAlign: "left" }}>Create Date</div>,
    accessor: "created_at",
    Cell: (props) => (
      <div>
        {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Name</div>,
    accessor: "first_name",
    Cell: (props) => <div>{props.value ? props.value : "-"}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Last Name</div>,
    accessor: "last_name",
    Cell: (props) => <div>{props.value ? props.value : "-"}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>เพศ</div>,
    accessor: "gender",
    Cell: (props) => <div>{props.value ? RENDER_GENDER_TYPE(props.value).labelTh : "-"}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>จังหวัด</div>,
    accessor: "province",
    Cell: (props) => <div>{props.value ? props.value : "-"}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>วันเกิด</div>,
    accessor: "birthday",
    Cell: (props) => (
      <div>
        {props.value
          ? momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY")
          : "-"}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Email</div>,
    accessor: "email",
    Cell: (props) => <div>{props.value ? props.value : "-"}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Edit by</div>,
    accessor: "updated_by",
    Cell: (props) => <div>{RENDER_EDIT_BY_TYPE(props.value).labelTh}</div>,
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CustomerEditLogContainer));
